import Account from './Account';
import AgencyStyle from './AgencyStyle';
import Api from './Api';
import Authentication from './Authentication';
import Confirm from './Confirm';
import Feature from './Feature';
import Help from './Help';
import Info from './Info';
import Menu from './Menu';
import Message from './Message';
import News from './News';
import Notify from './Notify';
import Permission from './Permission';
import Phone from './Phone';
import Print from './Print';
import Setting from './Setting';
import Utils from './Utils';

import TabEmitter from './_/TabEmitter';

export default class AppTemplate {
  component;
  loading = false;
  show = false;
  #title = document.title || '';
  promise;
  utils = Utils;
  emitters = {
    telephony: TabEmitter('telephony'),
    message: TabEmitter('notification'),
    events: TabEmitter('events'),
  };

  account = new Account(this);
  agencyStyle = new AgencyStyle(this);
  api = new Api(this);
  authentication = new Authentication(this);
  confirm = new Confirm(this);
  feature = new Feature(this);
  help = new Help(this);
  info = new Info(this);
  menu = new Menu(this);
  message = new Message(this);
  news = new News(this);
  notify = new Notify(this);
  phone = new Phone(this);
  permission = new Permission(this);
  print = new Print(this);
  setting = new Setting(this);

  get title() {
    return this.#title;
  }

  set title(value) {
    this.#title = value;
    document.title = value;
  }

  get load() {
    return this.loading || this.print.loading;
  }

  init() {
    if (!this.promise) {
      this.promise = this.api
        .get('/tourclient/account/extendedUserData')
        .then((data = {}) => {
          this.permission.init(data.Permissions || []);
          this.setting.init(data.MasterAgentSettings || {});
          this.account.init(data);
          this.agencyStyle.init(data);
          this.news.init(data);
          this.help.init(data);
          this.feature.init(data);
          this.authentication.init(data);
          this.info.init();
          this.message.init(data.NotReadedMessagesCount || 0);
          this.menu.init();
          this.show = true;
          return this;
        })
        .catch((e) => {
          if (window.location.href.toLowerCase()
            .indexOf('https://2015.mag.travel/tourclient/spa/#/registration') >= 0) {
            this.show = true;
            return Promise.resolve(this);
          }
          this.authentication.redirect();
          return Promise.reject(e);
        });
    }
    return this.promise;
  }
}
